import type { ProductSummary } from '@/domains/mobile-web/types/product.types';

interface CardTitleProps {
  product: ProductSummary;
  onOpen?: (product: ProductSummary) => void;
}

/** Product title of a card. With `onOpen` it is a button whose click area stretches over the
 *  whole card (the card needs `relative`, its own buttons `relative` to stay on top), so the
 *  card opens by mouse, touch and keyboard without nesting the card's buttons in a button. */
const CardTitle = ({ product, onOpen }: CardTitleProps) => {
  if (!onOpen) return <>{product.title}</>;
  return (
    <button
      type="button"
      onClick={() => onOpen(product)}
      className="cursor-pointer text-left after:absolute after:inset-0 after:content-['']"
    >
      {product.title}
    </button>
  );
};

export default CardTitle;
